import React from 'react';
import Skeleton from 'react-loading-skeleton';

/**
 * TailwindCSS version of ProductList skeleton loader (no inline style objects or SCSS module classes).
 * Mirrors the column structure of ProductList.
 */
export const ProductListSkeleton: React.FC = () => {
  // Predefined column width utility classes (fixed layout similar to original)
  const headerCells: { key: string; className: string }[] = [
    { key: 'title', className: 'w-[160px]' },
    { key: 'image', className: 'w-[92px]' },
    { key: 'availability', className: 'w-[100px]' },
    { key: 'tag', className: 'w-[140px]' },
    { key: 'category', className: 'w-[140px]' },
    { key: 'salePrice', className: 'w-[120px]' },
  ];

  const rows = Array.from({ length: 8 });

  return (
    <div className='flex flex-1 flex-col overflow-hidden bg-white/60'>
      <div className='flex h-full grow flex-col bg-white'>
        <div className='h-[635px] overflow-hidden'>
          <table className='w-full table-fixed'>
            <thead>
              <tr>
                {headerCells.map((c) => (
                  <th
                    key={c.key}
                    className={`${c.className} py-3 pl-5 text-left align-middle`}
                  >
                    <Skeleton height={18} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((_, rIndex) => (
                <tr key={rIndex} className='hover:bg-gray-50'>
                  {/* ID + Name */}
                  <td className='py-2 pl-5 align-middle'>
                    <div className='flex flex-col gap-1'>
                      <Skeleton height={14} width={180} />
                      <Skeleton height={10} width={90} />
                    </div>
                  </td>
                  {/* Image */}
                  <td className='py-2 pl-5 align-middle'>
                    <div className='flex min-h-[75px] items-center justify-center'>
                      <Skeleton height={75} width={75} />
                    </div>
                  </td>
                  {/* Availability */}
                  <td className='py-2 pl-5 align-middle'>
                    <Skeleton height={24} width={50} className='rounded-full' />
                  </td>
                  {/* Tags */}
                  <td className='py-2 pl-5 align-middle'>
                    <div className='flex gap-2'>
                      <Skeleton height={20} width={40} />
                      <Skeleton height={20} width={50} />
                      <Skeleton height={20} width={36} />
                    </div>
                  </td>
                  {/* Category */}
                  <td className='py-2 pl-5 align-middle'>
                    <Skeleton height={14} width={140} />
                  </td>
                  {/* Sale Price */}
                  <td className='py-2 pl-5 align-middle'>
                    <Skeleton height={14} width={70} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='h-[54px] w-full border-t border-gray-200 bg-gray-100'></div>
      </div>
    </div>
  );
};
